<mat-card>
    <mat-card-header>
        <mat-card-title>Iniciar Sesion en Ley de Murphy</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="loginForm" (ngSubmit)="onLogin(loginForm.value)">
            <p>
                <mat-form-field>
                    <input type="text" matInput placeholder="Email" formControlName="email">
                </mat-form-field>
            </p>
            <p>
                <mat-form-field>
                    <input type="password" matInput placeholder="Password" formControlName="password">
                </mat-form-field>
            </p>
            <button type="submit" mat-raised-button style="background-color: green;">Ingresar</button>
            <br>
            <br>
            <button style="background-color: red;" mat-raised-button (click)="registrar()">Registrarse</button>
        </form>
    </mat-card-content>
   
</mat-card>
